module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<div class="arangoToolbar arangoToolbarTop" style="margin-bottom: 5px;" id="rebalanceShards">\n  <div class="pull-right">\n    <button id="rebalanceShardsBtn" style="margin-left: 10px;" class="button-warning">Rebalance Shards</button>\n  </div>\n  <div style="font-size: 10pt; margin-left: 10px; margin-top: 12px; font-weight: 200">\n    <b>WARNING:</b> Clicking this button will start a\n      shard rebalancing process and schedule up to '+
((__t=( maxNumberOfMoveShards ))==null?'':__t)+
' shards move operations,\n      which may cause background activity and increase the load in the cluster until finished.</div>\n</div>\n\n';
}
return __p;
};
